import React from 'react';

import './ServicePage.css';

import BannerWithBreadcrumb from '../components/BannerWithBreadcrumb';

const weddingServices = [
  {
    id: 1,
    name: 'Dream Weddings',
    description: 'Full-service wedding planning and coordination.',
    address: '123 Wedding St, City',
    phone: '+91-9876543210',
    image: '/images/wedding1.png'
  },
  {
    id: 2,
    name: 'Elegant Events',
    description: 'Luxury event design and management.',
    address: '456 Event Ave, City',
    phone: '+91-9123456780',
    image: '/images/wedding2.png'
  },
];

const WeddingPlanning = () => (
  <div className="service-page">
    <BannerWithBreadcrumb
      title="Wedding Planning"
      breadcrumbItems={[
        { label: 'Home', link: '/' },
        { label: 'Wedding Planning' }
      ]}
    />
    <section className="content-section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="row g-4">
              {weddingServices.map((service) => (
                <div className="col-lg-4" key={service.id}>
                  <div className="card restaurant-card h-100">
                    <div className="restaurant-image">
                      <img src={service.image} alt={service.name} className="card-img-top" />
                      <div className="restaurant-overlay">
                        <span className="badge bg-primary cuisine-badge">Wedding</span>
                      </div>
                    </div>
                    <div className="card-body">
                      <h5 className="card-title mb-0">{service.name}</h5>
                      <p className="card-text">{service.description}</p>
                      <div className="restaurant-details">
                        <div className="detail-item">{service.address}</div>
                        <div className="detail-item">{service.phone}</div>
                      </div>
                    </div>
                    <div className="card-footer bg-transparent">
                      <button className="btn btn-outline-primary btn-sm">Book Now</button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
);

export default WeddingPlanning;
